import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from "lodash";
import { mapActions, mapState } from "vuex";
import { LOAD_EXTERNAL_SERVICES_STATUS } from "../store/status-page-actions";
import { OUTAGE_INCIDENT_STATUS } from "@Shared/@Types/status-page/types";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "IncidentMessage",
  props: {
    serviceName: {
      type: String,
      required: true
    },
    noSpacing: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState("StatusPageStore", ["externalServicesIncidents"])), {}, {
    incident() {
      return this.externalServicesIncidents.byId[this.serviceName] || {};
    },
    incidentStatus() {
      return this.incident.status;
    },
    hasIncident() {
      return !isEmpty(this.incident);
    },
    isMajorIncident() {
      var _context;
      return _includesInstanceProperty(_context = [OUTAGE_INCIDENT_STATUS.OUTAGE, OUTAGE_INCIDENT_STATUS.MAINTENANCE]).call(_context, this.incidentStatus);
    },
    disableService() {
      return this.hasIncident && this.isMajorIncident;
    },
    bannerStyleClasses() {
      switch (this.incidentStatus) {
        case OUTAGE_INCIDENT_STATUS.OUTAGE:
        case OUTAGE_INCIDENT_STATUS.MAINTENANCE:
          return "bg-danger text-white";
        case OUTAGE_INCIDENT_STATUS.DEGRADED:
          return "bg-warning text-dark";
        default:
          return "bg-danger text-white";
      }
    }
  }),
  watch: {
    disableService: {
      immediate: true,
      handler(value) {
        this.$emit("update", value);
      }
    }
  },
  mounted() {
    this.LOAD_EXTERNAL_SERVICES_STATUS(this.serviceName);
  },
  methods: _objectSpread({}, mapActions("StatusPageStore", [LOAD_EXTERNAL_SERVICES_STATUS]))
});